
export default function resetQuestions() {
    return {
        questionList1: [],
        questionList2: [],
        questionList3: [],
        questionList4:[],
        
        message: '',

        passedQuestion1: '',
        passedAnswer1: '',

        passedQuestion2 :'',
        passedAnswer2: '',

        passedQuestion3: '',
        passedAnswer3: '',

        passedQuestion4: '',
        passedAnswer4: '',

        isQuestion1: true,
        isQuestion2: true,
        isQuestion3: true,
        isQuestion4: true,

        isAnswer1: true,
        isAnswer2: true,
        isAnswer3: true,
        isAnswer4: true,

        isQuestion1Error: '',
        isQuestion2Error: '',
        isQuestion3Error: '',
        isQuestion4Error: '',

        isAnswer1Error: '',
        isAnswer2Error: '',
        isAnswer3Error: '',
        isAnswer4Error: '',

        primaryPhone: '',

        selectedQuestion1: '',
        selectedQuestion2: '',
        selectedQuestion3: '',
        selectedQuestion4: '',
        isSuccessMessage: false,

        async fetchSecurityQuestions() {
            try {
                await new Promise(resolve => setTimeout(resolve, 1000));
                const response = await fetch('/api/userAPI/GetSecurityQuestions');

                if (response.ok) {
                    const json = await response.json();
                    this.questionList1 = json;
                    this.questionList2 = json;
                    this.questionList3 = json;
                    this.questionList4 = json;
                }
            } catch (error) {
                console.error(error);
            }
        },
        OnChangeQuestion1(selectedQuestion1Value) {
            this.fetchSecurityQuestions().then(() => {
                this.questionList1 = this.questionList1.filter(item => 
                    item.text !== this.passedQuestion2 && item.text !== this.passedQuestion3 && item.text !== this.passedQuestion4);
                this.questionList2 = this.questionList2.filter(item => item.text !== selectedQuestion1Value
                    && item.text !== this.passedQuestion1 && item.text !== this.passedQuestion3 && item.text !== this.passedQuestion4);
                this.questionList3 = this.questionList3.filter(item => item.text !== selectedQuestion1Value
                    && item.text !== this.passedQuestion1 && item.text !== this.passedQuestion2 && item.text !== this.passedQuestion4);
                this.questionList4 = this.questionList4.filter(item => item.text !== selectedQuestion1Value
                    && item.text !== this.passedQuestion1 && item.text !== this.passedQuestion2 && item.text !== this.passedQuestion3);
                this.passedQuestion1 = selectedQuestion1Value;
                
            });

        },

        OnChangeQuestion2(selectedQuestion2Value) {
            this.fetchSecurityQuestions().then(() => {
                this.questionList1 = this.questionList1.filter(item => item.text !== selectedQuestion2Value
                    && item.text !== this.passedQuestion2 && item.text !== this.passedQuestion3 && item.text !== this.passedQuestion4);
                this.questionList2 = this.questionList2.filter(item => 
                     item.text !== this.passedQuestion1 && item.text !== this.passedQuestion3 && item.text !== this.passedQuestion4);
                this.questionList3 = this.questionList3.filter(item => item.text !== selectedQuestion2Value
                    && item.text !== this.passedQuestion1 && item.text !== this.passedQuestion2 && item.text !== this.passedQuestion4);
                this.questionList4 = this.questionList4.filter(item => item.text !== selectedQuestion2Value
                    && item.text !== this.passedQuestion1 && item.text !== this.passedQuestion2 && item.text !== this.passedQuestion3);
                this.passedQuestion2 = selectedQuestion2Value;
  
                //document.getElementById("question1").value = document.getElementById("hdnPassedQuestion1").value;
              
            });
        },
        OnChangeQuestion3(selectedQuestion3Value) {
            this.fetchSecurityQuestions().then(() => {
                this.questionList1 = this.questionList1.filter(item => item.text !== selectedQuestion3Value
                    && item.text !== this.passedQuestion2 && item.text !== this.passedQuestion3 && item.text !== this.passedQuestion4);
                this.questionList2 = this.questionList2.filter(item => item.text !== selectedQuestion3Value
                    && item.text !== this.passedQuestion1 && item.text !== this.passedQuestion3 && item.text !== this.passedQuestion4);
                this.questionList3 = this.questionList3.filter(item => 
                     item.text !== this.passedQuestion1 && item.text !== this.passedQuestion2 && item.text !== this.passedQuestion4);
                this.questionList4 = this.questionList4.filter(item => item.text !== selectedQuestion3Value
                    && item.text !== this.passedQuestion1 && item.text !== this.passedQuestion2 && item.text !== this.passedQuestion3);
                this.passedQuestion3 = selectedQuestion3Value;
                
            });
        },
        OnChangeQuestion4(selectedQuestion4Value) {
            this.fetchSecurityQuestions().then(() => {
                this.questionList1 = this.questionList1.filter(item => item.text !== selectedQuestion4Value
                    && item.text !== this.passedQuestion2 && item.text !== this.passedQuestion3 && item.text !== this.passedQuestion4);
                this.questionList2 = this.questionList2.filter(item => item.text !== selectedQuestion4Value
                    && item.text !== this.passedQuestion1 && item.text !== this.passedQuestion3 && item.text !== this.passedQuestion4);
                this.questionList3 = this.questionList3.filter(item => item.text !== selectedQuestion4Value
                    && item.text !== this.passedQuestion1 && item.text !== this.passedQuestion2 && item.text !== this.passedQuestion4);
                this.questionList4 = this.questionList4.filter(item => 
                     item.text !== this.passedQuestion1 && item.text !== this.passedQuestion2 && item.text !== this.passedQuestion3);
                this.passedQuestion4 = selectedQuestion4Value;
                
            });
        },
        resetData() {

            this.message = "";
            this.passedQuestion1 = "";
            this.passedAnswer1 = "";

            this.passedQuestion2 = "";
            this.passedAnswer2 = "";

            this.passedQuestion3 = "";
            this.passedAnswer3 = "";

            this.passedQuestion4 = "";
            this.passedAnswer4 = "";

        },
   
        updateSecurityQuestionsData() {


            if (this.passedQuestion1 == "") {
                this.isQuestion1 = false;
                this.isQuestion1Error = "Please select first security question";
                this.message = "";
            }
            else {
                this.isQuestion1 = true;
                this.isQuestion1Error = "";
            }
            if (this.passedQuestion2 == "") {
                this.isQuestion2 = false;
                this.isQuestion2Error = "Please select second security question";
                this.message = "";
            }
            else {
                this.isQuestion2 = true;
                this.isQuestion2Error = "";
            }
            if (this.passedQuestion3 == "") {
                this.isQuestion3 = false;
                this.isQuestion3Error = "Please select third security question";
                this.message = "";
            }
            else {
                this.isQuestion3 = true;
                this.isQuestion3Error = "";
            }
            if (this.passedQuestion4 == "") {
                this.isQuestion4 = false;
                this.isQuestion4Error = "Please select fourth security question";
                this.message = "";
            }
            else {
                this.isQuestion4 = true;
                this.isQuestion4Error = "";
            }
            if (this.passedAnswer1 == "") {
                this.isAnswer1 = false;
                this.isAnswer1Error = "Please enter answer of first security question";
                this.message = "";
            }
            else {
                this.isAnswer1 = true;
                this.isAnswer1Error = "";
            }
            if (this.passedAnswer2 == "") {
                this.isAnswer2 = false;
                this.isAnswer2Error = "Please enter answer of second security question";
                this.message = "";
            }
            else {
                this.isAnswer2 = true;
                this.isAnswer2Error = "";
            }
            if (this.passedAnswer3 == "") {
                this.isAnswer3 = false;
                this.isAnswer3Error = "Please enter answer of third security question";
                this.message = "";
            }
            else {
                this.isAnswer3 = true;
                this.isAnswer3Error = "";
            }
            if (this.passedAnswer4 == "") {
                this.isAnswer4 = false;
                this.isAnswer4Error = "Please enter answer of fourth security question";
                this.message = "";
            }
            else {
                this.isAnswer4 = true;
                this.isAnswer4Error = "";
            }
            if (this.isQuestion1 && this.isQuestion2 && this.isQuestion3 && this.isQuestion4 && this.isAnswer1 &&
                this.isAnswer2 && this.isAnswer3 && this.isAnswer4) {
                fetch('/api/UserAPI/UpdateSecurityQuestions', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        Question1: this.passedQuestion1,
                        Answer1: this.passedAnswer1,
                        Question2: this.passedQuestion2,
                        Answer2: this.passedAnswer2,
                        Question3: this.passedQuestion3,
                        Answer3: this.passedAnswer3,
                        Question4: this.passedQuestion4,
                        Answer4: this.passedAnswer4,

                    })
                })
                    .then(response => {
                        if (response.ok) {
                            return response.json()
                        }
                    }).then(response => {

                        if (response.isSuccess) {
                            this.isSuccessMessage = true;
                            this.message = "Information updated successfully";
                        } else {
                            this.isSuccessMessage = false;
                            this.message = "Something went wrong";
                        }

                    });
            }
        },

        init() {
            this.fetchSecurityQuestions();
        }
    }
}